/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { GetLable } from '../../../../Config/GetLabels'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  let Settings: any = { LanguageSelection:  true};
  const storedData = localStorage.getItem("mapConfiguration");
  let regexp = /android|iphone|kindle|ipad/i;
  const desktopOrMobile = navigator.userAgent;
  let isMobileDevice = regexp.test(desktopOrMobile);

  if (storedData !== null) {
    Settings = isMobileDevice ? JSON.parse(storedData).mobileConfig : JSON.parse(storedData).desktopConfig;
  };

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/300-1.jpg')} />
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.last_name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      {/* Map Configuration */}
      <div className='menu-item px-5'>
        <Link to={'./mapconfiguration'} className='menu-link px-5'>
          <GetLable label="MapConfiguration" />
        </Link>
      </div>
      <div className='separator my-2'></div>
      {Settings.LanguageSelection ? <Languages /> : null}
      <div className='menu-item px-5'>
        <Link to="auth" onClick={logout} className='menu-link px-5'>
          <GetLable label="SignOut" />
        </Link>
      </div>
    </div>
  )
}
export { HeaderUserMenu }
